import FindPlan from '~components/FindPlan/FindPlan';
import Trustpilot from '~components/Trustpilot/Trustpilot';
import useWindowSize from '~hooks/useWindowSize';

const AfterSummaryZipContainer = ({ children }: React.PropsWithChildren) => {
    const { isDesktop } = useWindowSize();

    return (
        <>
            {children}
            {!isDesktop && (
                <>
                    <FindPlan
                        title="See plans in your area instantly!"
                        zipContainerClasses="md:flex md:justify-center"
                    />
                    <Trustpilot size="newthin" className="py-4 print:hidden" />
                </>
            )}
        </>
    );
};

export default AfterSummaryZipContainer;
